import { useEffect, useState } from 'react';

const useImageLoader = (imageUrl: string | undefined, initialLoadingFlag = false) => {
  const [isLoading, setIsLoading] = useState(initialLoadingFlag);

  useEffect(() => {
    if (imageUrl) {
      const isPerpetualLoad = imageUrl === 'imageLoadingStateLoading';
      const onLoadComplete = () => setIsLoading(false);
      const onError = () => setIsLoading(false);

      const image = document.createElement('img');
      if (!isPerpetualLoad) {
        image.addEventListener('load', onLoadComplete);
        image.addEventListener('error', onError);
        image.src = imageUrl;
      }
      /*
       * Genuine external-system sync: `image.complete` can only be read off the `img` element
       * created above, so the initial loading state isn't derivable during render.
       */
      // oxlint-disable-next-line react/set-state-in-effect
      setIsLoading(isPerpetualLoad ? true : !image.complete);

      return () => {
        setIsLoading(false);
        image.removeEventListener('load', onLoadComplete);
        image.removeEventListener('error', onError);
        image.remove();
      };
    }

    return;
  }, [imageUrl, setIsLoading]);

  return isLoading;
};

export default useImageLoader;
